module.exports = __webpack_public_path__ + "static/img/eat-type-bg.b038ed6f.png";